export default {
  Info:{
    token:'',
    sk:'',
    imei:'',
    stat_time:'',
  }
}



// WEBPACK FOOTER //
// ./src/Serves/Info.js